import { Switch, Route } from "wouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme-provider";

import Home from "@/pages/home";
import NotFound from "@/pages/not-found";

export default function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />

          <Switch>
            <Route path="/">
              <Home />
            </Route>

            <Route>
              <NotFound />
            </Route>
          </Switch>

        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
